module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errorWrap"
  }, [_c('div', {
    staticClass: "iconfont icon-wushuju icon"
  }, [_c('span', [_vm._v("暂无数据")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af19a7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/error/error.vue
// module id = 269
// module chunks = 1